var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForgotPasswordEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.608 57.2772L83.8676 97.5228L75.0538 104.375C73.2639 105.791 70.7361 105.791 68.9462 104.375L60.1324 97.5228L8.39173 57.2772C8.92541 56.0924 9.69403 55.0281 10.651 54.149L19.8621 45.6579L55.8869 12.4138L66.96 2.18483C69.8046 -0.447209 74.1955 -0.447209 77.04 2.18483L88.1131 12.4138L124.138 45.6579L133.349 54.149C134.306 55.0281 135.075 56.0924 135.608 57.2772Z",
    fill: "#0F8858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.138 110.349V17.3793C124.13 14.6403 121.911 12.422 119.172 12.4138H24.8276C22.0886 12.422 19.8703 14.6403 19.8621 17.3793V110.979L124.138 110.349Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1324 97.5228L10.9738 140.897C8.71373 138.731 7.4396 135.734 7.44828 132.604V61.4483C7.44484 60.0046 7.76734 58.5789 8.39173 57.2772L60.1324 97.5228Z",
    fill: "#14C57F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.026 140.897C130.962 142.893 128.201 144.006 125.33 144H18.6703C15.7988 144.006 13.038 142.893 10.9738 140.897L60.1324 97.5228L68.9462 104.375C70.7361 105.791 73.2639 105.791 75.0538 104.375L83.8676 97.5228L133.026 140.897Z",
    fill: "#0DA86B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.552 61.4483V132.604C136.56 135.734 135.286 138.731 133.026 140.897L83.8676 97.5228L135.608 57.2772C136.233 58.5789 136.555 60.0046 136.552 61.4483Z",
    fill: "#14C57F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 24.8276C55.5457 24.8276 42.2069 38.1664 42.2069 54.6207C42.2069 71.075 55.5457 84.4138 72 84.4138C78.3801 84.4366 84.596 82.3922 89.717 78.5868C90.818 77.7695 91.0481 76.2144 90.2309 75.1134C89.4137 74.0123 87.8586 73.7822 86.7575 74.5994C82.4918 77.7685 77.314 79.4698 72 79.4483C58.2881 79.4483 47.1724 68.3326 47.1724 54.6207C47.1724 40.9088 58.2881 29.7931 72 29.7931C85.7119 29.7931 96.8276 40.9088 96.8276 54.6207V59.5862C96.8276 62.3286 94.6045 64.5517 91.8621 64.5517C89.1197 64.5517 86.8966 62.3286 86.8966 59.5862V42.2069C86.8966 40.8357 85.785 39.7241 84.4138 39.7241C83.0426 39.7241 81.931 40.8357 81.931 42.2069V43.5476C77.4332 39.5024 70.9356 38.5789 65.4888 41.2108C60.042 43.8426 56.7276 49.5071 57.1017 55.5448C57.4757 61.5826 61.464 66.7946 67.194 68.7339C72.9241 70.6733 79.2579 68.9548 83.2221 64.3854C85.4 68.3523 89.9914 70.3364 94.373 69.2041C98.7545 68.0719 101.81 64.1117 101.793 59.5862V54.6207C101.775 38.1738 88.4469 24.8454 72 24.8276ZM72 64.5517C66.5152 64.5517 62.069 60.1054 62.069 54.6207C62.069 49.1359 66.5152 44.6897 72 44.6897C77.4848 44.6897 81.931 49.1359 81.931 54.6207C81.931 60.1054 77.4848 64.5517 72 64.5517Z",
    fill: "#0DA86B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordEmail);
export default __webpack_public_path__ + "static/media/forgot-password-email.c634a50f.svg";
export { ForwardRef as ReactComponent };